import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { PenStanchionDto } from 'models/pen/PenStanchion';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenStanchionService extends BaseApiService<PenStanchionDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenStanchionDto);
  }

  async getPenStanchionss(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenStanchionDto[]>(`api/pen-stanchion/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }
}
